<template>
  <aside class="left-sidebar">
    <div class="scroll-sidebar">
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li class="sidebar-item">
            <router-link :to="{ name: 'dashboard'}" aria-expanded="false" class="sidebar-link waves-effect waves-dark" exact>
              <i class="fas fa-tachometer-alt" /><span class="hide-menu">Dashboard</span>
            </router-link>
          </li>
          <li v-if="currentUser && currentUser.email === 'contact@qlikchain.com'" class="sidebar-item ">
            <router-link :to="{ name: 'new-template'}" class="sidebar-link waves-effect waves-dark" exact>
              <i class="fas fa-clipboard-list" /><span class="hide-menu"> Manage Template</span>
            </router-link>
          </li>
          <li class="sidebar-item ">
            <router-link :to="{ name: 'myaudits'}" class="sidebar-link waves-effect waves-dark" exact>
              <i class="fas fa-clipboard-list" /><span class="hide-menu"> My Audits</span>
            </router-link>
          </li>
          <li class="sidebar-item ">
            <router-link :to="{ name: 'assignedaudits'}" class="sidebar-link waves-effect waves-dark" exact>
              <i class="fas fa-clipboard-check" /><span class="hide-menu"> Assigned Audits</span>
            </router-link>
          </li>
          <li class="sidebar-item ">
            <router-link :to="{ name: 'newaudit'}" class="sidebar-link waves-effect waves-dark" exact>
              <i class="mdi mdi-plus-circle-multiple-outline" /><span class="hide-menu"> New Audit</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WorkspaceMenubar',
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    handleLogout () {
      this.$store.commit('LOGOUT')
      this.$router.replace('/auth/login')
    }
  }
}
</script>

<style scoped>
.subitem {
  padding-left: 15px;
}
</style>
<style>
.sidebar-nav ul .sidebar-item .sidebar-link.router-link-active {
  opacity: 1;
}
</style>
